module.exports = __webpack_public_path__ + "media/site_templates/www.buildingjobs.net.au/images/our_services_1-e739b0e5e0a9bc110479b06684302792.jpg";